<h1 class="text-dark text-xl" mat-dialog-title>
  {{ msData.id ? 'Modifica Maggiore Sconto' : 'Nuovo Maggiore Sconto' }}
</h1>
<div class="w-full" mat-dialog-content>
  <app-ms-discount-form [data]="msData" [modalTrigger$]="modalTrigger"></app-ms-discount-form>
</div>
